import { render } from "./LinkExterno.vue?vue&type=template&id=3031436e"
const script = {}
script.render = render

export default script